import { useEffect, useRef, useState } from "react";
import CommonService from "../../services/common.service";
import { Empty, Skeleton } from "antd";
import { Card } from "react-bootstrap";
import moment from "moment";
import { useStateContext } from "../../contexts/ContextProvider";

const AllEmployeeTree = ({ contentRef, fullScreen, leaveStatus }) => {
  const [loading, setLoading] = useState(false);
  const [allEmpList2, setAllEmpList2] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedEmpData, setSelectedEmpData] = useState({});

  const { windowHeight, setWindowHeight } = useStateContext();

  const fetchEmpList = (leaveStatus) => {
    const payload = {
      location: "",
    };
    setLoading(true);
    CommonService.getEmpBasicInfoByLoc(payload)
      .then((resp) => {
        if (resp.data) {
          const data = resp.data;

          const statusPriority = {
            Present: "1",
            OnLeave: "1",
            Resigned: "2",
          };

          // let sortedByLeaveStatus = data.sort((a, b) => {
          //   return (
          //     statusPriority[a.leaveStatus] - statusPriority[b.leaveStatus]
          //   );
          // });

           let sortedByLeaveStatus = data.filter(
             (item) => statusPriority[item.leaveStatus] === leaveStatus
           );

          const locationWiseData = Object.values(
            sortedByLeaveStatus.reduce((acc, emp) => {
              if (!acc[emp.location]) {
                acc[emp.location] = {
                  location: emp.location,
                  sortedByLeaveStatus: [],
                  presentCount: 0,
                  resignedCount: 0,
                };
              }
              acc[emp.location].sortedByLeaveStatus.push(emp);
              // Count present and absent
              if (
                emp.leaveStatus === "Present" ||
                emp.leaveStatus === "OnLeave"
              ) {
                acc[emp.location].presentCount += 1;
              } else if (emp.leaveStatus === "Resigned") {
                acc[emp.location].resignedCount += 1;
              }
              return acc;
            }, {})
          );
          setAllEmpList2(locationWiseData);

          setLoading(false);
        }
      })
      .catch((e) => console.log(e), setLoading(false));
  };

  useEffect(() => {
    fetchEmpList(leaveStatus);
  }, [leaveStatus]);

  const fetchSelectedEmpData = (empId) => {
    const paylaod = {
      EmpId: empId,
    };

    CommonService.getEmpDetailsByID(paylaod)
      .then((resp) => {
        if (resp.data) {
          setSelectedEmpData(resp.data[0]);
        }
      })
      .catch((e) => console.log(e));
  };

  const showModal = (empId) => {
    setShow(true);
    fetchSelectedEmpData(empId);
  };

  useEffect(() => {
    let h = window.innerHeight;
    // console.log("height", h);
    setWindowHeight(h - 300);
  }, [windowHeight]);

  return (
    <>
      <div ref={contentRef}>
        <div className="compInfo mb-3">
          <span>Aeon software</span>
          <span>
            <svg
              width="6"
              height="16"
              viewBox="0 0 6 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 16L5.88675 11L0.113248 11L3 16ZM2.5 -2.18557e-08L2.5 11.5L3.5 11.5L3.5 2.18557e-08L2.5 -2.18557e-08Z"
                fill="#887B9D"
              />
            </svg>
          </span>
        </div>
        <div className="scroll scroll2">
          <div className="flex">
            {Array.isArray(allEmpList2)
              ? allEmpList2.map((item2) => {
                  return (
                    <>
                      <div className="item2">
                        <div className="compInfo">
                          <span>
                            {item2.location} {item2.sortedByLeaveStatus.length}
                          </span>
                        </div>
                        <div
                          className="list emp-cardlist2"
                          style={{ height: fullScreen ? "85vh" : windowHeight, overflow: "scroll" }}
                        >
                          <div className="row">
                            {loading ? (
                              <Skeleton active={loading} />
                            ) : allEmpList2.length === 0 ? (
                              <div className="d-flex align-items-center justify-content-center w-100">
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                              </div>
                            ) : (
                              <>
                                {Array.isArray(item2.sortedByLeaveStatus)
                                  ? item2.sortedByLeaveStatus.map((item) => {
                                      return (
                                        <>
                                          <div className="col-md-6 p-1">
                                            <Card
                                              className={
                                                "p-1 " + item.leaveStatus
                                              }
                                              onClick={(e) => {
                                                showModal(item.empId);
                                              }}
                                            >
                                              <div className="profile">
                                                {item.empProfilePicName !==
                                                "" ? (
                                                  <>
                                                    <div className="p-circle2">
                                                      <img
                                                        src={`https://elmsbk.aeontechhub.com/ProfilePic/${item.empId}/${item.empProfilePicName}`}
                                                        width="30px"
                                                        alt=""
                                                      />
                                                    </div>
                                                  </>
                                                ) : (
                                                  <>
                                                    {item.gender === "Male" ? (
                                                      <>
                                                        <img
                                                          src="https://avatar.iran.liara.run/public/boy"
                                                          width="30px"
                                                          alt=""
                                                        />
                                                      </>
                                                    ) : (
                                                      <>
                                                        <img
                                                          src="https://avatar.iran.liara.run/public/girl"
                                                          width="30px"
                                                          alt=""
                                                        />
                                                      </>
                                                    )}
                                                  </>
                                                )}
                                                <div className="profile-info2 d-flex flex-column">
                                                  <span className="name">
                                                    {item.name}
                                                  </span>
                                                  <span className="desig">
                                                    {item.designation}
                                                  </span>
                                                </div>
                                              </div>
                                            </Card>
                                          </div>
                                        </>
                                      );
                                    })
                                  : null}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })
              : null}
          </div>
        </div>
        <div
          className={`${show ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setShow(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div
              className={`${
                show ? "filterByModal visible" : "filterByModal hidden"
              }`}
            >
              <div className="sort-list">
                {selectedEmpData && (
                  <>
                    <p>Name: {selectedEmpData.name}</p>
                    <p>Email: {selectedEmpData.email}</p>
                    <p>Mobile: {selectedEmpData.mobileno}</p>
                    <p>
                      Date of Birth:{" "}
                      {selectedEmpData.dob !== "" && (
                        <>
                          {moment(selectedEmpData.dob, "YYYY-MM-DD").format(
                            "D MMMM YYYY"
                          )}
                        </>
                      )}
                    </p>
                    <p>Maritial Status: {selectedEmpData.maritial_Status}</p>

                    <hr />

                    <p>Designation: {selectedEmpData.designation}</p>
                    <p>Department: {selectedEmpData.department}</p>
                    <p>Role: {selectedEmpData.userRole}</p>
                    <p>Reparting Manager: {selectedEmpData.rmName}</p>
                    <p>Payroll: {selectedEmpData.payroll}</p>
                    <p>Location: {selectedEmpData.location}</p>
                    <p>
                      Joining Date:{" "}
                      {selectedEmpData.joiningdate !== "" && (
                        <>
                          {" "}
                          {moment(
                            selectedEmpData.joiningdate,
                            "YYYY-MM-DD"
                          ).format("D MMMM YYYY")}
                        </>
                      )}
                    </p>
                    <p>
                      Confirmation Date:{" "}
                      {selectedEmpData.comfirmation_date !== "" && (
                        <>
                          {" "}
                          {moment(
                            selectedEmpData.comfirmation_date,
                            "YYYY-MM-DD"
                          ).format("D MMMM YYYY")}
                        </>
                      )}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllEmployeeTree;
